import React, { useState } from 'react'

const CATALOGUE = [
  { title: 'The House in the Cerulean Sea',        author: 'TJ Klune',              genre: 'Fantasy',     desc: 'A cosy fantasy about an unlikely found family.' },
  { title: 'Mexican Gothic',                        author: 'Silvia Moreno-Garcia',  genre: 'Horror',      desc: 'Gothic horror in 1950s Mexico.' },
  { title: 'Piranesi',                              author: 'Susanna Clarke',         genre: 'Fantasy',     desc: 'A man lives alone in a labyrinthine house filled with tides.' },
  { title: 'The Midnight Library',                  author: 'Matt Haig',             genre: 'Literary',    desc: 'Infinite lives between life and death.' },
  { title: 'Normal People',                         author: 'Sally Rooney',          genre: 'Literary',    desc: 'Two people who keep finding their way back to each other.' },
  { title: 'Educated',                              author: 'Tara Westover',          genre: 'Non-Fiction', desc: 'A memoir of self-invention and survival.' },
  { title: 'The Song of Achilles',                  author: 'Madeline Miller',       genre: 'Historical',  desc: 'A retelling of the Iliad through the eyes of Patroclus.' },
  { title: 'Where the Crawdads Sing',               author: 'Delia Owens',           genre: 'Mystery',     desc: 'A girl who raised herself in the North Carolina marshes.' },
  { title: 'Anxious People',                        author: 'Fredrik Backman',       genre: 'Literary',    desc: 'A hostage situation that becomes something entirely else.' },
  { title: 'The Starless Sea',                      author: 'Erin Morgenstern',      genre: 'Fantasy',     desc: 'A love letter to stories and the act of storytelling.' },
  { title: 'The Seven Husbands of Evelyn Hugo',     author: 'Taylor Jenkins Reid',   genre: 'Romance',     desc: 'A fictional Hollywood legend finally tells her truth.' },
  { title: 'Project Hail Mary',                     author: 'Andy Weir',             genre: 'Sci-Fi',      desc: 'One man wakes up alone on a mission to save humanity.' },
  { title: 'The Invisible Life of Addie LaRue',     author: 'V.E. Schwab',          genre: 'Fantasy',     desc: 'Cursed to be forgotten by everyone she meets.' },
  { title: 'In the Woods',                          author: 'Tana French',           genre: 'Mystery',     desc: 'A detective with a buried past investigates a murder.' },
  { title: 'Pachinko',                              author: 'Min Jin Lee',           genre: 'Historical',  desc: 'Four generations of a Korean family in Japan.' },
  { title: "The Hitchhiker's Guide to the Galaxy",  author: 'Douglas Adams',         genre: 'Sci-Fi',      desc: 'The universe is stranger and funnier than you think.' },
  { title: 'A Little Life',                         author: 'Hanya Yanagihara',      genre: 'Literary',    desc: 'Four friends and the weight of one life.' },
  { title: 'Braiding Sweetgrass',                   author: 'Robin Wall Kimmerer',   genre: 'Non-Fiction', desc: 'Indigenous wisdom and the science of plants.' },
  { title: 'The Name of the Wind',                  author: 'Patrick Rothfuss',      genre: 'Fantasy',     desc: 'A legend sits down to tell the story of his own life.' },
  { title: 'Convenience Store Woman',               author: 'Sayaka Murata',         genre: 'Literary',    desc: 'A woman finds perfect clarity in her convenience store.' },
  // Additional 22
  { title: 'Never Let Me Go',                       author: 'Kazuo Ishiguro',        genre: 'Literary',    desc: 'Three friends at a school where a terrible truth hangs in the air.' },
  { title: 'The God of Small Things',               author: 'Arundhati Roy',         genre: 'Literary',    desc: 'Twin siblings in Kerala and the summer that shattered their lives.' },
  { title: 'Rebecca',                               author: 'Daphne du Maurier',     genre: 'Thriller',    desc: 'A new wife is haunted by the ghost of the first Mrs de Winter.' },
  { title: 'The Night Circus',                      author: 'Erin Morgenstern',      genre: 'Fantasy',     desc: 'Two magicians compete in an enchanted black-and-white circus.' },
  { title: 'Circe',                                 author: 'Madeline Miller',       genre: 'Fantasy',     desc: 'A witch from myth discovers what she is capable of.' },
  { title: 'The Thursday Murder Club',              author: 'Richard Osman',         genre: 'Mystery',     desc: 'Four retirees investigate unsolved crimes — with lethal efficiency.' },
  { title: 'Gone Girl',                             author: 'Gillian Flynn',         genre: 'Thriller',    desc: 'A woman vanishes on her wedding anniversary. Her husband becomes the suspect.' },
  { title: 'Beach Read',                            author: 'Emily Henry',           genre: 'Romance',     desc: 'Two rival writers swap genres for the summer and fall for each other.' },
  { title: 'Wolf Hall',                             author: 'Hilary Mantel',         genre: 'Historical',  desc: 'Thomas Cromwell rises through the Tudor court with quiet, devastating intelligence.' },
  { title: "Ender's Game",                          author: 'Orson Scott Card',      genre: 'Sci-Fi',      desc: 'A boy genius is trained in zero-gravity warfare to save humanity.' },
  { title: 'Children of Time',                     author: 'Adrian Tchaikovsky',    genre: 'Sci-Fi',      desc: 'Spiders evolve a civilisation; humans search for a new world.' },
  { title: 'The Pillars of the Earth',              author: 'Ken Follett',           genre: 'Historical',  desc: 'Building a cathedral in 12th-century England becomes a life\'s obsession.' },
  { title: 'Eleanor Oliphant is Completely Fine',   author: 'Gail Honeyman',         genre: 'Literary',    desc: 'A woman who lives by rigid routine has her world gently cracked open.' },
  { title: 'The Body',                              author: 'Bill Bryson',           genre: 'Non-Fiction', desc: 'A guided tour of everything that goes on inside a human body.' },
  { title: 'Sapiens',                               author: 'Yuval Noah Harari',     genre: 'Non-Fiction', desc: 'A brief history of humankind from the Stone Age to the present.' },
  { title: 'Red Rising',                            author: 'Pierce Brown',          genre: 'Sci-Fi',      desc: 'A miner infiltrates the ruling class to bring down a caste system.' },
  { title: 'The Girl with the Dragon Tattoo',       author: 'Stieg Larsson',         genre: 'Thriller',    desc: 'A journalist and a hacker investigate a decades-old disappearance in Sweden.' },
  { title: 'Stardust',                              author: 'Neil Gaiman',           genre: 'Fantasy',     desc: 'A young man crosses a wall into a magical kingdom to find a fallen star.' },
  { title: 'The Alchemist',                         author: 'Paulo Coelho',          genre: 'Literary',    desc: 'A shepherd boy follows signs across the desert toward his destiny.' },
  { title: 'The Way of Kings',                      author: 'Brandon Sanderson',     genre: 'Fantasy',     desc: 'Three people are bound by war, storm, and an ancient secret.' },
  { title: 'And Then There Were None',              author: 'Agatha Christie',       genre: 'Mystery',     desc: 'Ten strangers are lured to an island and killed one by one.' },
  { title: 'Attachment',                            author: 'Rainbow Rowell',        genre: 'Romance',     desc: 'A man falls for a woman through her emails — without her knowing.' },
]

const GENRE_COLORS = {
  Fantasy:      { bg: 'rgba(120,80,220,0.1)',  color: '#7850dc' },
  Thriller:     { bg: 'rgba(220,60,60,0.1)',   color: '#c83232' },
  Literary:     { bg: 'rgba(80,130,80,0.1)',   color: '#3a7a3a' },
  'Non-Fiction':{ bg: 'rgba(60,120,200,0.1)', color: '#2a6ab4' },
  Historical:   { bg: 'rgba(180,130,60,0.1)',  color: '#9a6820' },
  Mystery:      { bg: 'rgba(80,160,160,0.1)',  color: '#2a8888' },
  Romance:      { bg: 'rgba(220,80,140,0.1)',  color: '#c0306a' },
  'Sci-Fi':     { bg: 'rgba(40,160,200,0.1)',  color: '#2080a0' },
  Horror:       { bg: 'rgba(40,20,60,0.1)',    color: '#5a1a8a' },
  Poetry:       { bg: 'rgba(200,160,40,0.1)',  color: '#8a6a00' },
}

const ALL_GENRES = [...new Set(CATALOGUE.map(b => b.genre))].sort()

export default function ReadingSuggestions({ books }) {
  const [showAll,     setShowAll]     = useState(false)
  const [filterGenre, setFilterGenre] = useState('')
  const [showFilter,  setShowFilter]  = useState(false)

  const libraryTitles = new Set(books.map(b => b.title?.toLowerCase()))
  const available = CATALOGUE.filter(s => !libraryTitles.has(s.title.toLowerCase()))

  const filtered = filterGenre
    ? available.filter(b => b.genre === filterGenre)
    : available

  const DEFAULT_SHOWN = 3
  const shown = showAll ? filtered : filtered.slice(0, DEFAULT_SHOWN)

  if (available.length === 0) {
    return (
      <p style={{ fontSize: '0.88rem', color: 'var(--stone)', fontStyle: 'italic', fontFamily: 'var(--font-serif)', lineHeight: 1.65 }}>
        You have all our suggestions in your library already. Impressive collection.
      </p>
    )
  }

  const gc = g => GENRE_COLORS[g] || { bg: 'rgba(0,0,0,0.06)', color: 'var(--stone)' }

  return (
    <div>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '0.75rem', flexWrap: 'wrap', gap: 8 }}>
        <p style={{ fontSize: '0.85rem', color: 'var(--stone)', lineHeight: 1.65, margin: 0 }}>
          Books from our quiet library — curated, never algorithmic.
          {available.length < CATALOGUE.length && (
            <span style={{ color: 'var(--bark)', fontStyle: 'italic' }}>
              {' '}({CATALOGUE.length - available.length} already on your shelf.)
            </span>
          )}
        </p>
        <button
          className="suggestions-filter-toggle"
          onClick={() => setShowFilter(v => !v)}
        >
          {filterGenre ? `${filterGenre} ✕` : 'Filter by genre'}
        </button>
      </div>

      {showFilter && (
        <div className="suggestions-filter-panel">
          <div className="suggestions-filter-genre-chips">
            {ALL_GENRES.map(g => (
              <button
                key={g}
                className={`suggestions-genre-chip${filterGenre === g ? ' active' : ''}`}
                onClick={() => {
                  setFilterGenre(prev => prev === g ? '' : g)
                  setShowAll(false)
                }}
              >
                {g}
              </button>
            ))}
          </div>
          {filterGenre && (
            <button className="suggestions-filter-clear" onClick={() => { setFilterGenre(''); setShowAll(false) }}>
              Clear filter
            </button>
          )}
        </div>
      )}

      {filtered.length === 0 ? (
        <p style={{ fontSize: '0.85rem', color: 'var(--stone)', fontStyle: 'italic' }}>
          No unread suggestions in this genre.
        </p>
      ) : (
        <>
          <div className="suggestions-grid">
            {shown.map(book => (
              <div key={book.title} className="suggestion-card">
                <div
                  className="suggestion-genre"
                  style={{ background: gc(book.genre).bg, color: gc(book.genre).color }}
                >
                  {book.genre}
                </div>
                <div className="suggestion-title">{book.title}</div>
                <div className="suggestion-author">{book.author}</div>
                <div className="suggestion-desc">{book.desc}</div>
              </div>
            ))}
          </div>
          {!showAll && filtered.length > DEFAULT_SHOWN && (
            <button className="suggestions-more-btn" onClick={() => setShowAll(true)}>
              Show {filtered.length - DEFAULT_SHOWN} more
            </button>
          )}
          {showAll && filtered.length > DEFAULT_SHOWN && (
            <button className="suggestions-more-btn" onClick={() => setShowAll(false)}>
              Show fewer
            </button>
          )}
        </>
      )}
    </div>
  )
}
